// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29qFF","right":"styles_right__3IQRL"};